'use client';

import {createContext} from 'react';

interface Ctx {
  activeIdx: number;

  setActiveIdx(idx: number): void;
}

const ShowcaseContextNew = createContext<Ctx>({
  activeIdx: 0,
  setActiveIdx: () => undefined,
});

export default ShowcaseContextNew;
